<template>
  <v-container fluid>
    <v-parallax 
    :src="require('@/assets/compass.jpg')"
    aspect-ratio="1.7"
    height="300"
    class="my-2">
      <v-layout align-center justify-space-around row wrap fill-height>
        <h1 class="display-3 font-weight-thin white--text ma-2">Nuestros Servicios</h1>
      </v-layout>
    </v-parallax>
    <v-layout row wrap>
      <v-flex class="my-4">
        <v-layout row wrap 
        text-xs-center 
        justify-center
        class="my-2">
          <h1 class="display-2 font-weight-thin my-2">M&amp;A y Aumento de Capital</h1>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/handshakecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="shadow">
                              <h1 class="display-2 font-weight-thin white--text">Fusiones &amp; Adquisiciones</h1>
                              <h2 class="display-5 font-weight-thin white--text">Adquisición, fusión o venta total o parcial de empresas.</h2>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">Asesoramiento estratégico y táctico diferenciado, así como una ejecución eficiente:
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showMAD = !showMAD">
                          <div>{{ showMAD ? 'Leer Menos' : 'Leer Mas' }}</div>
                        </v-btn>
                        <v-btn icon @click="showMAD = !showMAD">
                          <v-icon>{{ showMAD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showMAD">
                          <template v-for="(maDetail, i) in maDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{maDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{maDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{maDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/es/contacto'">Contáctenos</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex sm12 md6>
        <v-container
          fluid
          grid-list-lg
        >
          <v-layout row wrap>
            <v-flex xs12>
              <v-hover>
                <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`">
                  <v-parallax
                  :src="require('@/assets/singaporecolor.jpg')"
                  >
                    <v-container fill-height>
                      <v-layout align-center>
                        <v-layout row wrap>
                          <v-flex xs12>
                            <div class="shadow">
                              <h1 class="display-2 font-weight-thin white--text">Aumento de Capital</h1>
                              <h2 class="display-5 font-weight-thin white--text">Soluciones directas de capital privado, crédito o financiamiento híbrido: </h2>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-parallax>

                  <v-card-title primary-title>
                    <div>
                      <div class="headline ml-2">Aprovechamos nuestra amplia experiencia en la ejecución de transacciones complejas para ayudar a abordar sus objetivos, que incluyen:
                        <v-spacer></v-spacer>
                        <v-btn flat  @click="showCRD = !showCRD">
                          <div>{{ showCRD ? 'Leer Menos' : 'Leer Mas' }}</div>
                        </v-btn>
                        <v-btn icon @click="showCRD = !showCRD">
                          <v-icon>{{ showCRD ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
                        </v-btn>
                      </div>
                      <v-slide-y-transition>
                        <v-list three-line
                        v-show="showCRD">
                          <template v-for="(crDetail, i) in crDetails">

                            <v-list-tile
                              :key="i"
                              avatar
                              class="my-2"
                            >
                              <v-list-tile-avatar>
                                <v-icon color="accent">{{crDetail.icon}}</v-icon>
                              </v-list-tile-avatar>

                              <v-list-tile-content>
                                <v-list-tile-title>{{crDetail.title}}</v-list-tile-title>
                                <v-list-tile-sub-title>{{crDetail.subtitle}}</v-list-tile-sub-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                        </v-list>
                      </v-slide-y-transition>
                    </div>
                  </v-card-title>
                  
                  <v-card-actions>
                    <v-layout 
                    align-center 
                    justify-center 
                    row wrap 
                    fill-height
                    class="mb-2">
                      <v-btn 
                      color="accent"
                      class="white--text"
                      :to="'/es/contacto'">Contáctenos</v-btn>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        showMAD: true,
        showCRD: true,
        maDetails: [
          {
            icon: 'assignment_turned_in',
            title: 'Evaluación de Transacción',
            subtitle: 'Evaluamos objetivos potenciales, proporcionamos análisis de valoración y evaluamos y proponemos alternativas financieras y estratégicas.'
          },
          {
            icon: 'question_answer',
            title: 'Asesoramiento Independiente',
            subtitle: 'Proporcionamos a los consejos directivos y equipos de gestión con criterio independiente y profunda experiencia geográfica y del sector.'
          },
          {
            icon: 'gavel',
            title: 'Ejecución del Trato',
            subtitle: 'También asesoramos sobre el calendario, la estructura, el financiamiento y los precios de una transacción propuesta, así como también ayudamos a negociar y cerrar el trato.'
          }
        ],
        crDetails: [
          {
            icon: 'work',
            title: 'Ventas de Capital Privado',
            subtitle: 'Colocaciones de acciones tradicionales y pre-IPO para compañías privadas, y reemplazos de accionistas.'
          },
          {
            icon: 'trending_up',
            title: 'Capital de Crecimiento',
            subtitle: 'Financiamiento de adquisición, financiamiento de deuda y financiamiento de proyectos.'
          },
          {
            icon: 'autorenew',
            title: 'Recapitalización',
            subtitle: 'Recapitalizaciones de patrimonio de la compañía / refinanciamientos de deuda, refinanciamiento de deuda soberana, inversiones privadas en entidades públicas ("PIPEs") para empresas públicas.'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .shadow {
    position: absolute;
    top: 30%;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    color: white;
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/servicios.vue